import { FcGoogle } from "react-icons/fc";
import { REDIRECT_URL } from "../../config/constant";

const GoogleLogin = (props: any) => {
    const handleClick = (e:any) => { 
    e.preventDefault();
    // Perform any additional logic here if needed
    window.location.href = REDIRECT_URL + window.location.href;
  }; 
    return (
        <button type="button" className="btn-line btn-google w-100" onClick={handleClick}>
            {FcGoogle({ className: "" })}
            <span className="m-xs-l">
                Sign in with Google
            </span> 
        </button> 
    );
};

export default GoogleLogin;